<script lang="ts">
	import { page } from '$app/stores';
	import ChevronDown from '$lib/icons/chevronDown.svelte';
	import { derived } from 'svelte/store';
	import { slide } from 'svelte/transition';
	import type { SbBlogArticleCategoryStory } from '../types';
	import CategoryFilterBubble from './categoryFilterBubble.svelte';
	import clickOutside from '$lib/actions/clickOutside';
	import { goto } from '$app/navigation';

	interface Props {
		categoriesPromise: Promise<SbBlogArticleCategoryStory[]>;
		onselect: (category: SbBlogArticleCategoryStory | null) => void;
	}

	let { categoriesPromise, onselect }: Props = $props();

	let open = $state(false);

	const selectedCategoryName = derived([page], ([p]) => {
		if (p.state.selectedBlogArticleCategory)
			return p.state.selectedBlogArticleCategory.content.name;

		return p.route.id?.startsWith('/news') ? 'Latest news' : 'Latest stories';
	});

	function selectCategory(category: SbBlogArticleCategoryStory | null) {
		open = false;
		onselect(category);
	}
</script>

{#if categoriesPromise}
	{#await categoriesPromise then categories}
		<div class="relative z-50" in:slide>
			<button
				type="button"
				class="flex items-center gap-x-2 lg:text-[18px]"
				onclick={(e) => {
					e.stopPropagation();
					open = !open;
				}}
			>
				{$selectedCategoryName}
				<div class="transform-gpu transition-transform" class:rotate-180={open}>
					<ChevronDown class="h-6 w-6" />
				</div>
			</button>
			<div class="absolute z-50 mt-10">
				{#if open}
					<ul
						transition:slide
						class="flex flex-col gap-y-4 text-[16px]/[110%] font-semibold"
						use:clickOutside={() => {
							open = false;
						}}
					>
						{#if !$page.route.id?.startsWith('news/')}
							<CategoryFilterBubble
								active={!$page.state.selectedBlogArticleCategory}
								onclick={() => {
									selectCategory(null);
									goto('/blog');
								}}>Latest stories</CategoryFilterBubble
							>
						{/if}

						{#each categories as category, i}
							<CategoryFilterBubble
								index={i}
								active={$page.state.selectedBlogArticleCategory?.uuid === category.uuid}
								onclick={() => selectCategory(category)}
								>{category.content.name}</CategoryFilterBubble
							>
						{/each}
					</ul>
				{/if}
			</div>
		</div>
	{/await}
{/if}
